import { ReactNode } from 'react';
import styled, { CSSProperties } from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { HeadlineL, LabelL } from '@sorare/core/src/atoms/typography';

import bg from 'components/rivals/Onboarding/FavoriteClubSelection/ClubSelectionDialog/assets/bg.svg';

const Root = styled(Vertical)`
  height: 100%;
  justify-content: space-between;
  padding: calc(var(--unit) * 9) var(--double-unit);
  background:
    linear-gradient(to bottom, var(--bg-color), var(--bg-color)),
    no-repeat center / cover url(${bg});
`;

type Props = {
  color?: string | null;
  title: ReactNode;
  subtitle: ReactNode;
  content?: ReactNode;
  footer?: ReactNode;
};
export const BaseLayout = ({
  color,
  title,
  subtitle,
  content,
  footer,
}: Props) => {
  return (
    <Root style={{ '--bg-color': `${color}46` } as CSSProperties}>
      <Vertical gap={0.5}>
        <HeadlineL>{title}</HeadlineL>
        <LabelL color="var(--c-nd-600)">{subtitle}</LabelL>
      </Vertical>
      {content}
      <div>{footer}</div>
    </Root>
  );
};
